import React from 'react'
import { t } from './i18n/i18n'
import { Text } from './components/common/text/Text'
import { Image, tokens } from '@fluentui/react-components'
import { makeStyles, Card, mergeClasses } from '@fluentui/react-components'

const useStyles = makeStyles({
   centerColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
   },
   wrapper: {
      position: 'absolute',
      top: '45%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      width: '70vw',
      borderRadius: tokens.borderRadiusLarge,
      gap: tokens.spacingHorizontalXXS,
      boxSizing: 'border-box',
      maxHeight: '100%',
      boxShadow: tokens.shadow8,
      padding: `${tokens.spacingVerticalXXL} ${tokens.spacingHorizontalXXXL}`,
      backgroundColor: tokens.colorPaletteMarigoldBackground1,
   },
   appVersion: {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translate(-50%, -50%)',
   },
})
export const MobileUnderConstruction = () => {
   const classes = useStyles()
   const packageJson = require('../package.json')
   const appVersion = packageJson.version

   return (
      <article className={classes.centerColumn}>
         <Image src="365Robust.svg" alt={t('365Robust') + 'logo'} height={80} />
         <Card className={mergeClasses(classes.wrapper)}>
            <Text size={500} weight="medium" align="center">
               {t('MobileViewUnderConstruction')}
            </Text>

            <Text size={400} align="center">
               {t('PleaseUseComputerToAccessTheApplication')}
            </Text>

            <Text size={400} align="center">
               {t('KindRegards365RobustTeam')}
            </Text>
         </Card>
         <Text className={classes.appVersion} align="center">
            v {appVersion}
         </Text>
      </article>
   )
}
